import { Typography } from '@mui/material';

export interface SlidePaginationControlsProps {
  currentIndex: number;
  totalSlides: number;
}

export function SlidePaginationControls({
  currentIndex,
  totalSlides,
}: SlidePaginationControlsProps) {
  if (totalSlides <= 1) {
    return null;
  }

  const currentPage = currentIndex + 1;

  return (
    <Typography variant="body-xs">
      Page {currentPage} of {totalSlides}
    </Typography>
  );
}
